// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Content Approvals — match Access Requests / dashboard layout styles.
   Child pages need their own .submission-field offset (Angular encapsulation). */
/* Flowchest button styling */
.btn {
  font-family: inherit !important;
  font-weight: 500 !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
  cursor: pointer !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  min-height: 40px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  box-sizing: border-box !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
}

.btn-primary {
  background-color: #5ea1d8 !important;
  color: #fff !important;
  border: none !important;
}

.btn-primary:hover {
  background-color: #4a8bc4 !important;
  box-shadow: 0 2px 6px rgba(94, 161, 216, 0.25) !important;
}

.btn-warn {
  background-color: #c62828 !important;
  color: #fff !important;
  border: none !important;
}

.btn-warn:hover {
  background-color: #b71c1c !important;
  box-shadow: 0 2px 6px rgba(198, 40, 40, 0.25) !important;
}

.btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Summary cards (same as access-requests) */
.com-record {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
  border: none !important;
}

.com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
}

.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
}

.followers-tag .box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
  gap: 12px;
}

.followers-tag .box .icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.followers-tag .box .ico-box {
  width: 40px;
  height: 40px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
}

.followers-tag .box .card-icon {
  font-size: 20px;
  color: #5ea1d8;
}

.followers-tag .box .text {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
  justify-content: center;
  gap: 2px;
}

.followers-tag .box .text .count {
  background: white !important;
  box-shadow: none !important;
  display: flex;
  align-items: center;
}

.followers-tag .box .text .count b {
  font-size: 24px;
  font-weight: 700 !important;
  color: #333;
  display: block;
  line-height: 1.2;
}

.followers-tag .box .text p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.2;
  display: block;
}

/* Dashboard shell layout — required so content is not under the left menu */
.setting-dashboard {
  padding: 0;
  height: auto;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}

.dashbored-wrap {
  padding-left: 0px;
  margin-top: 0;
}
.dashbored-wrap .table-wrap {
  padding: 30px 30px 30px 0;
  width: 100%;
  left: 0;
}
.dashbored-wrap .filter {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  border: none;
  padding: 0 0 16px;
}
.dashbored-wrap .table-parent {
  overflow-x: auto;
  margin-top: -8px;
}

.filters-section {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: nowrap;
  align-items: center;
  overflow: visible;
}
.filters-section .flow-filter {
  display: flex;
  align-items: center;
  min-width: 200px;
  max-width: 240px;
  overflow: visible;
}
.filters-section .flow-filter .status-filter {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #fff;
  font-size: 14px;
  font: inherit;
  color: #333;
}

.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important;
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0;
}

.guide-link {
  cursor: pointer;
  color: #5ea1d8;
  font-weight: 600;
}
.guide-link:hover {
  text-decoration: underline;
}

.type-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 999px;
  background: #eef6fc;
  color: #1565c0;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.type-badge mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.type-badge--pack {
  background: #f3eefc;
  color: #6941c6;
}

.scheduled-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  background: #fff4e5;
  color: #b54708;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.scheduled-badge mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.submitter {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.submitter .muted {
  font-size: 12px;
  color: #667085;
}

.review-comment {
  width: 100%;
  height: 38px;
  box-sizing: border-box;
  margin: 0;
  padding: 0 12px;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  background: #fff;
  color: #1f2328;
  font-size: 13px;
}
.review-comment:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);
}

:host-context(body.theme-dark) .filters-section .status-filter {
  background: #0f172a;
  color: #e5e7eb;
  border-color: rgba(148, 163, 184, 0.3);
}
:host-context(body.theme-dark) .type-badge {
  background: #1a2c3d;
  color: #7ec8f0;
}
:host-context(body.theme-dark) .type-badge--pack {
  background: rgba(105, 65, 198, 0.2);
  color: #c4b5fd;
}
:host-context(body.theme-dark) .submitter .muted {
  color: #98a2b3;
}
:host-context(body.theme-dark) .scheduled-badge {
  background: rgba(181, 71, 8, 0.2);
  color: #fdba74;
}
:host-context(body.theme-dark) .review-comment {
  background: #1b1f27;
  border-color: #2f3542;
  color: #e2e8f0;
}
:host-context(body.theme-dark) .link-btn {
  color: #7ec8f0;
}
:host-context(body.theme-dark) .decision-btn--reject {
  background: transparent;
  color: #fda29b;
  border-color: rgba(240, 68, 56, 0.45);
}
:host-context(body.theme-dark) .decision-btn--reject:hover:not(:disabled) {
  background: rgba(240, 68, 56, 0.12);
}

.fc-table td {
  vertical-align: top;
}

.actions-cell {
  width: 340px;
  min-width: 300px;
}

.review-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.review-panel__links {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
}
.review-panel__decision {
  display: flex;
  gap: 8px;
}

.link-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 0;
  border: none;
  background: none;
  color: #1d67a3;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.link-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.link-btn:hover:not(:disabled) {
  text-decoration: underline;
}
.link-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.decision-btn {
  flex: 1 1 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 38px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.decision-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.decision-btn--approve {
  background: #12b76a;
  color: #fff;
}
.decision-btn--approve:hover:not(:disabled) {
  background: #039855;
  box-shadow: 0 2px 6px rgba(18, 183, 106, 0.3);
}
.decision-btn--reject {
  background: #fff;
  color: #b42318;
  border-color: #fda29b;
}
.decision-btn--reject:hover:not(:disabled) {
  background: #fef3f2;
  border-color: #f97066;
}
.decision-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 767px) {
  .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0px;
  }
  .setting-dashboard .submission-field .hamburger .dash-title {
    width: 100%;
    top: calc(var(--app-header, 56px) + 48px);
    height: 40px;
  }
  .dashbored-wrap {
    margin-top: 10px !important;
  }
  .dashbored-wrap .table-wrap {
    padding: 0px;
  }
  .followers-tag {
    gap: 12px;
  }
  .followers-tag .box {
    width: 100%;
    margin: 6px 0;
    min-width: auto;
    border-radius: 8px;
  }
  .com-record {
    padding: 12px 16px 20px;
  }
  .filter,
  .filters-section {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .filters-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 16px;
    padding: 0 20px;
  }
  .filters-section .flow-filter {
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/content-approvals/content-approvals.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;iFAAA;AAGA,6BAAA;AACA;EACE,+BAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,2BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iCAAA;EACA,4BAAA;EACA,0BAAA;AACF;;AAEA;EACE,oCAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oCAAA;EACA,yDAAA;AACF;;AAEA;EACE,oCAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oCAAA;EACA,wDAAA;AACF;;AAEA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;AACF;;AAEA,4CAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,QAAA;AACF;;AAEA;EACE,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA,4EAAA;AACA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AACF;AACE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAGA;EACE,iBAAA;EACA,aAAA;AAAF;AAEE;EACE,yBAAA;EACA,WAAA;EACA,OAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AADJ;AAIE;EACE,gBAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAHF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;AAKI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAHN;;AAQA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AALF;;AAQA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AALF;;AAQA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AALF;;AAQA;EACE,gBAAA;EACA,iCAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AALF;AAOE;EACE,oBAAA;AALJ;;AASA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AANF;AAQE;EACE,0BAAA;AANJ;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAPF;AASE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAPJ;AAUE;EACE,mBAAA;EACA,cAAA;AARJ;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AATF;AAWE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AATJ;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAVF;AAYE;EACE,eAAA;EACA,cAAA;AAVJ;;AAcA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAXF;AAaE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAXJ;;AAgBE;EACE,mBAAA;EACA,cAAA;EACA,sCAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,cAAA;AAdJ;AAgBI;EACE,mCAAA;EACA,cAAA;AAdN;AAkBE;EACE,cAAA;AAhBJ;AAmBE;EACE,iCAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAlBJ;AAqBE;EACE,cAAA;AAnBJ;AAsBE;EACE,uBAAA;EACA,cAAA;EACA,qCAAA;AApBJ;AAsBI;EACE,mCAAA;AApBN;;AAyBA;EACE,mBAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtBF;AAwBE;EACE,aAAA;EACA,eAAA;EACA,aAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,QAAA;AAvBJ;;AA2BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAxBF;AA0BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxBJ;AA2BE;EACE,0BAAA;AAzBJ;AA4BE;EACE,YAAA;EACA,mBAAA;AA1BJ;;AA8BA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,oFAAA;AA3BF;AA6BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3BJ;AA8BE;EACE,mBAAA;EACA,WAAA;AA5BJ;AA8BI;EACE,mBAAA;EACA,6CAAA;AA5BN;AAgCE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AA9BJ;AAgCI;EACE,mBAAA;EACA,qBAAA;AA9BN;AAkCE;EACE,YAAA;EACA,mBAAA;AAhCJ;;AAoCA;EACE;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EAjCF;EAoCA;IACE,WAAA;IACA,SAAA;EAlCF;EAqCA;IACE,WAAA;IACA,yCAAA;IACA,YAAA;EAnCF;EAsCA;IACE,2BAAA;EApCF;EAuCA;IACE,YAAA;EArCF;EAwCA;IACE,SAAA;EAtCF;EAyCA;IACE,WAAA;IACA,aAAA;IACA,eAAA;IACA,kBAAA;EAvCF;EA0CA;IACE,uBAAA;EAxCF;EA2CA;;IAEE,sBAAA;IACA,0BAAA;IACA,sBAAA;EAzCF;EA4CA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;IACA,eAAA;EA1CF;EA6CA;IACE,uBAAA;IACA,0BAAA;IACA,sBAAA;EA3CF;AACF","sourcesContent":["/* Content Approvals — match Access Requests / dashboard layout styles.\n   Child pages need their own .submission-field offset (Angular encapsulation). */\n\n/* Flowchest button styling */\n.btn {\n  font-family: inherit !important;\n  font-weight: 500 !important;\n  border-radius: 8px !important;\n  transition: all 0.2s ease !important;\n  cursor: pointer !important;\n  text-transform: none !important;\n  letter-spacing: 0 !important;\n  min-height: 40px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 6px !important;\n  box-sizing: border-box !important;\n  padding: 8px 16px !important;\n  font-size: 14px !important;\n}\n\n.btn-primary {\n  background-color: #5ea1d8 !important;\n  color: #fff !important;\n  border: none !important;\n}\n\n.btn-primary:hover {\n  background-color: #4a8bc4 !important;\n  box-shadow: 0 2px 6px rgba(94, 161, 216, 0.25) !important;\n}\n\n.btn-warn {\n  background-color: #c62828 !important;\n  color: #fff !important;\n  border: none !important;\n}\n\n.btn-warn:hover {\n  background-color: #b71c1c !important;\n  box-shadow: 0 2px 6px rgba(198, 40, 40, 0.25) !important;\n}\n\n.btn:disabled {\n  opacity: 0.6 !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Summary cards (same as access-requests) */\n.com-record {\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 0;\n  padding: 20px 30px 30px;\n  border: none !important;\n}\n\n.com-record:after {\n  content: \"\";\n  width: 100%;\n  height: 60%;\n  top: 0px;\n  position: absolute;\n  left: 0px;\n  z-index: 0;\n}\n\n.followers-tag {\n  display: flex;\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.followers-tag .box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  gap: 12px;\n}\n\n.followers-tag .box .icon {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.followers-tag .box .ico-box {\n  width: 40px;\n  height: 40px;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0;\n}\n\n.followers-tag .box .card-icon {\n  font-size: 20px;\n  color: #5ea1d8;\n}\n\n.followers-tag .box .text {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  flex: 1;\n  justify-content: center;\n  gap: 2px;\n}\n\n.followers-tag .box .text .count {\n  background: white !important;\n  box-shadow: none !important;\n  display: flex;\n  align-items: center;\n}\n\n.followers-tag .box .text .count b {\n  font-size: 24px;\n  font-weight: 700 !important;\n  color: #333;\n  display: block;\n  line-height: 1.2;\n}\n\n.followers-tag .box .text p {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n  line-height: 1.2;\n  display: block;\n}\n\n/* Dashboard shell layout — required so content is not under the left menu */\n.setting-dashboard {\n  padding: 0;\n  height: auto;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n}\n\n.dashbored-wrap {\n  padding-left: 0px;\n  margin-top: 0;\n\n  .table-wrap {\n    padding: 30px 30px 30px 0;\n    width: 100%;\n    left: 0;\n  }\n\n  .filter {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n    border: none;\n    padding: 0 0 16px;\n  }\n\n  .table-parent {\n    overflow-x: auto;\n    margin-top: -8px;\n  }\n}\n\n.filters-section {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: nowrap;\n  align-items: center;\n  overflow: visible;\n\n  .flow-filter {\n    display: flex;\n    align-items: center;\n    min-width: 200px;\n    max-width: 240px;\n    overflow: visible;\n\n    .status-filter {\n      width: 100%;\n      height: 40px;\n      box-sizing: border-box;\n      padding: 0 12px;\n      border-radius: 4px;\n      border: 1px solid #ddd;\n      background-color: #fff;\n      font-size: 14px;\n      font: inherit;\n      color: #333;\n    }\n  }\n}\n\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  color: #fff;\n  width: 83.333333%;\n}\n\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important;\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n\n  .dash-text {\n    padding: 10px 15px 0;\n  }\n}\n\n.guide-link {\n  cursor: pointer;\n  color: #5ea1d8;\n  font-weight: 600;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background: #eef6fc;\n  color: #1565c0;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n  }\n\n  &--pack {\n    background: #f3eefc;\n    color: #6941c6;\n  }\n}\n\n.scheduled-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 6px;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background: #fff4e5;\n  color: #b54708;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.submitter {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n\n  .muted {\n    font-size: 12px;\n    color: #667085;\n  }\n}\n\n.review-comment {\n  width: 100%;\n  height: 38px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0 12px;\n  border: 1px solid #d0d7de;\n  border-radius: 8px;\n  background: #fff;\n  color: #1f2328;\n  font-size: 13px;\n\n  &:focus {\n    outline: none;\n    border-color: #5ea1d8;\n    box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);\n  }\n}\n\n:host-context(body.theme-dark) {\n  .filters-section .status-filter {\n    background: #0f172a;\n    color: #e5e7eb;\n    border-color: rgba(148, 163, 184, 0.3);\n  }\n\n  .type-badge {\n    background: #1a2c3d;\n    color: #7ec8f0;\n\n    &--pack {\n      background: rgba(105, 65, 198, 0.2);\n      color: #c4b5fd;\n    }\n  }\n\n  .submitter .muted {\n    color: #98a2b3;\n  }\n\n  .scheduled-badge {\n    background: rgba(181, 71, 8, 0.2);\n    color: #fdba74;\n  }\n\n  .review-comment {\n    background: #1b1f27;\n    border-color: #2f3542;\n    color: #e2e8f0;\n  }\n\n  .link-btn {\n    color: #7ec8f0;\n  }\n\n  .decision-btn--reject {\n    background: transparent;\n    color: #fda29b;\n    border-color: rgba(240, 68, 56, 0.45);\n\n    &:hover:not(:disabled) {\n      background: rgba(240, 68, 56, 0.12);\n    }\n  }\n}\n\n.fc-table td {\n  vertical-align: top;\n}\n\n.actions-cell {\n  width: 340px;\n  min-width: 300px;\n}\n\n.review-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &__links {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px 12px;\n  }\n\n  &__decision {\n    display: flex;\n    gap: 8px;\n  }\n}\n\n.link-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 0;\n  border: none;\n  background: none;\n  color: #1d67a3;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n\n  &:hover:not(:disabled) {\n    text-decoration: underline;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.decision-btn {\n  flex: 1 1 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 38px;\n  padding: 0 14px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &--approve {\n    background: #12b76a;\n    color: #fff;\n\n    &:hover:not(:disabled) {\n      background: #039855;\n      box-shadow: 0 2px 6px rgba(18, 183, 106, 0.3);\n    }\n  }\n\n  &--reject {\n    background: #fff;\n    color: #b42318;\n    border-color: #fda29b;\n\n    &:hover:not(:disabled) {\n      background: #fef3f2;\n      border-color: #f97066;\n    }\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n@media (max-width: 767px) {\n  .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0px;\n  }\n\n  .setting-dashboard .submission-field .hamburger .dash-title {\n    width: 100%;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: 40px;\n  }\n\n  .dashbored-wrap {\n    margin-top: 10px !important;\n  }\n\n  .dashbored-wrap .table-wrap {\n    padding: 0px;\n  }\n\n  .followers-tag {\n    gap: 12px;\n  }\n\n  .followers-tag .box {\n    width: 100%;\n    margin: 6px 0;\n    min-width: auto;\n    border-radius: 8px;\n  }\n\n  .com-record {\n    padding: 12px 16px 20px;\n  }\n\n  .filter,\n  .filters-section {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n  }\n\n  .filters-section {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding: 0 20px;\n  }\n\n  .filters-section .flow-filter {\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
